import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";

import { initializeApp } from "firebase/app";

var firebaseConfig = {
  apiKey: "AIzaSyCNXy5cCQZdNEnSOOXecJb-ejMfpLOxRK0",
  authDomain: "wrapp-waste.firebaseapp.com",
  databaseURL: "https://wrapp-waste.firebaseio.com",
  projectId: "wrapp-waste",
  storageBucket: "wrapp-waste.appspot.com",
  messagingSenderId: "662553288814",
  appId: "1:662553288814:web:90dd222d1fe2d6766ac67f",
  measurementId: "G-KV0CXS3XRV"
};
initializeApp(firebaseConfig);

const db = getFirestore();

function getWasteTypesForArea(postalCode) {
  const q = query(collection(db, 'service-provider-areas'), where('postalCodeEnd', '>=', postalCode));
  return getDocs(q)
}

const fastQuoteModule = {
  state: () => ({
    loading: false,
    wasteTypes: undefined,
    vehicles: undefined,
    areas: [],
    waste: undefined,
    order: undefined,
    quoteId: null,
    emails: []
  }),
  getters: {
    isLoading(state) {
      return state.loading;
    },
    getOrder(state) {
      return state.order;
    },
    getWasteTypes(state) {
      return state.wasteTypes;
    },
    getWaste(state) {
      return state.waste;
    },
    getVehicles(state) {
      return state.vehicles;
    },
    getAreas(state){
      return state.areas;
    },
    getQuoteId(state){
      return state.quoteId;
    }
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setOrder(state, order){
      state.order = order;
    },
    setWasteType(state, wasteTypes) {
      state.wasteTypes = wasteTypes;
    },
    setWaste(state, waste) {
      state.waste = waste;
    },
    setVehicles(state, vehicles) {
      state.vehicles = vehicles;
    },
    setAreas(state, areas){
      state.areas = areas;
    },
    setQuoteId(state, id){
      state.quoteId = id;
    },
    setEmails(state, email) {
      state.emails.push(email);
    }
  },
  actions: {
    fetchOrder(context){
      getDocs(collection(db, 'quotes'))
      .then((snapshot) => {
        let numbers = [];
        let num = snapshot.docs.length;
        snapshot.docs.forEach((booking) =>{
          if (booking.data().order){
            numbers.push(booking.data().order);
          }
        })
        if(numbers.length > 0){
          let order = Math.max.apply(null, numbers);
          console.log(order);
          context.commit('setOrder', order);
        }
        else{
          context.commit('setOrder', num);
        }
      })
      .catch((err) => {
        console.log(err);
      })
    },
    fetchWasteTypesByArea(context, postalCode) {
      getWasteTypesForArea(postalCode)
        .then((querySnapshot) => {
          if(querySnapshot.empty){
            alert("Sorry, we currently don’t service this area. Please contact us on 072 245 9777 so that we can 'Get it Sorted'");
            location.reload();
          }
          else{
            const vehicles = [];
            const wasteTypes = [];
            querySnapshot.docs.forEach((doc) => {
              const data = doc.data();
              if(data.wasteTypes){
                if (postalCode >= data.postalCodeStart && postalCode <= data.postalCodeEnd) {
                  data.wasteTypes.forEach((wasteType) => {
                    wasteType.vehicles.forEach((vehicle) => {
                      vehicles.push(vehicle);
                    });
                    wasteTypes.push({ ...wasteType, serviceProviderId: data.serviceProviderId });
                  });
                  context.commit('setVehicles', vehicles);
                  context.commit('setWasteType', wasteTypes);
                }
              }
            })
            if(vehicles.length < 1 || wasteTypes.length < 1){
              alert("Sorry, we currently don’t service this area. Please contact us on 072 245 9777 so that we can 'Get it Sorted'");
              location.reload();
            }
          }
      }).catch((err) => {
        console.log(err);
        alert("Something went wrong. Please contact us on 072 245 9777 so that we can 'Get it Sorted'");
        location.reload();
      })
    },
    fetchAreas(context){
      let areas = [];
      getDocs(collection(db, 'service-provider-areas'))
      .then((snapshot) => {
        snapshot.forEach((snap) => {
          areas.push({...snap.data(), id: snap.id});
        })
        context.commit('setAreas', areas);
      })   
    },
    fetchQuoteId(context, id){
      context.commit('setQuoteId', id);
    },
    sendPipeDriveDeal(_context, data){
      console.log(data)
      fetch(`https://us-central1-wrapp-waste.cloudfunctions.net/pipeDriveDeal`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .catch(err => console.error(err))
    }
  }
}

export default fastQuoteModule;
